@let ctrl = control();
<mat-form-field>
  <mat-label>G4 kundenummer</mat-label>
  <input id="g4Account" matInput [formControl]="ctrl" />
  @if (ctrl.hasError('required')) {
    <mat-error>G4 kundenummer er påkrævet</mat-error>
  }
  @if (ctrl.hasError('pattern')) {
    <mat-error>kundenummer skal være et tal på 5 til 7 cifre</mat-error>
  }
  @if (ctrl.pending) {
    <ok-form-field-loading></ok-form-field-loading>
  }
</mat-form-field>
@if (ctrl.hasError('customerDoesNotExist')) {
  <ok-feedback-fail>
    <b>Vi kunne ikke finde en kunde ud fra det angivne G4 kundenummer</b>
  </ok-feedback-fail>
}
@if (ctrl.valid && ctrl.value && customerDetails(); as details) {
  <ok-feedback-success>
    <div>
      Kunden <b>{{ details.name }}</b> blev fundet.<br />
      Tlf. nummer:<b> {{ details.phone_number }}</b
      ><br />
      Email :<b> {{ details.email }}</b>
    </div>
  </ok-feedback-success>
}
